var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'container',
        { grow: _vm.grow, 'has-value': _vm.value, error: _vm.error, disabled: _vm.disabled, 'has-limit': _vm.limit },
    ],attrs:{"data-value":_vm.grow ? _vm.value : ''}},[_c('textarea',{class:[
            {
                'has-value': _vm.value,
                error: _vm.error,
                disabled: _vm.disabled,
                'apply-important-border-style-hack':
                    _vm.applyImportantBorderStyleHack,
            },
        ],attrs:{"disabled":_vm.disabled || null,"maxlength":_vm.limit,"placeholder":_vm.label.length ? '' : _vm.placeHolder},domProps:{"value":_vm.value},on:{"focus":function($event){return _vm.$emit('focus', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"input":function($event){return _vm.$emit('input', $event.target.value)}}}),(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.limit)?_c('span',{staticClass:"limit"},[_vm._v(" "+_vm._s(_vm.currentLimit)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }